import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/studentCategory'
import {combineEpics} from 'redux-observable'

export const studentCategoryEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)